import BaseInput from "../input/BaseInput";
import BaseLabel from "../label/BaseLabel";
import BaseSelect from "../select/BaseSelect";

interface BaseOption {
  key: number;
  value: number | string;
}

const BaseField: React.FC<{
  id: string;
  className?: string;
  type?: string;
  label?: string;
  value?: string | number | undefined;
  checked?: boolean;
  options?: BaseOption[];
  required?: boolean;
  direction?: "vertical" | "horisontal";
  onChange: (e: any) => void;
}> = ({
  id,
  className,
  type,
  label,
  value,
  checked,
  options,
  onChange,
  required,
  direction,
}) => {
  return (
    <div className={`control field ${direction}`}>
      {label && (
        <BaseLabel
          id={id}
          className={`${type === "checkbox" ? "checkbox-label" : ""} ${className ? className : ""} ${direction}`}
          text={label || ""}
        />
      )}
      {type && type === "select" ? (
        <BaseSelect
          id={id}
          className={`${className ? className : ""} ${direction}`}
          value={value}
          onChange={onChange}
          required={required}
          options={options || []}
        />
      ) : (
        <BaseInput
          id={id}
          className={`${className ? className : ""} ${direction}`}
          type={type}
          value={value}
          checked={checked}
          onChange={onChange}
          required={required}
        />
      )}
    </div>
  );
};

export default BaseField;
